export enum SituacaoAgendamento {
    Marcado,
    EmEspera,
    EmAndamento,
    Faltou,
    Finalizado,
    Cancelado
}
